import React, { useState } from 'react';
import { FaBriefcase, FaMapMarkerAlt, FaMoneyBillWave, FaExternalLinkAlt, FaRocket, FaBuilding } from 'react-icons/fa';

const PlacementPortal = () => {
  const [jobs] = useState([
    // MNC & REFERENCED ROLES
    { id: 1, title: "Business Analyst", company: "IBM", salary: "12-15 LPA", location: "Bangalore, India", link: "https://careers.ibm.com/en_US/careers/JobDetail?jobId=83909", type: "MNC", category: "Analyst" },
    { id: 2, title: "Software Engineer", company: "Microsoft", salary: "25-35 LPA", location: "Hyderabad/Bangalore", link: "https://apply.careers.microsoft.com/careers/job/1970393556745075", type: "MNC", category: "Development" },
    { id: 3, title: "Associate Consultant", company: "Deloitte", salary: "9-12 LPA", location: "Gurugram, India", link: "#", type: "MNC", category: "Consulting" },
    { id: 4, title: "Cloud Practitioner", company: "Amazon (AWS)", salary: "18-22 LPA", location: "Remote/Bangalore", link: "#", type: "MNC", category: "Cloud" },
    { id: 5, title: "Data Analyst Trainee", company: "Google", salary: "20-28 LPA", location: "Bangalore", link: "#", type: "MNC", category: "Data" },
    
    // TRENDING TECH ROLES (LinkedIn/Naukri Style)
    { id: 6, title: "Frontend Developer (React)", company: "Zomato", salary: "14-18 LPA", location: "Gurugram", link: "#", type: "Product", category: "Development" },
    { id: 7, title: "Python Developer", company: "J.P. Morgan", salary: "15-20 LPA", location: "Mumbai", link: "#", type: "MNC", category: "Finance Tech" },
    { id: 8, title: "Digital Marketing Associate", company: "Nykaa", salary: "6-9 LPA", location: "Mumbai", link: "#", type: "Product", category: "Marketing" },
    { id: 9, title: "Cybersecurity Analyst", company: "Accenture", salary: "8-11 LPA", location: "Chennai", link: "#", type: "MNC", category: "Security" },
    { id: 10, title: "Full Stack Engineer", company: "PhonePe", salary: "16-22 LPA", location: "Bangalore", link: "#", type: "Product", category: "Development" },
    
    // DIVERSE INDUSTRY ROLES
    { id: 11, title: "QA Automation Engineer", company: "Infosys", salary: "5-8 LPA", location: "Mysore", link: "#", type: "MNC", category: "Testing" },
    { id: 12, title: "UX/UI Designer", company: "Flipkart", salary: "12-16 LPA", location: "Bangalore", link: "#", type: "Product", category: "Design" },
    { id: 13, title: "Machine Learning Intern", company: "NVIDIA", salary: "Stipend: 50k", location: "Pune", link: "#", type: "MNC", category: "AI/ML" },
    { id: 14, title: "HR Operations", company: "Wipro", salary: "4-6 LPA", location: "Kochi", link: "#", type: "MNC", category: "HR" },
    { id: 15, title: "Salesforce Developer", company: "Capgemini", salary: "7-10 LPA", location: "Hyderabad", link: "#", type: "MNC", category: "Development" },
    
    // STARTUP & INNOVATION ROLES
    { id: 16, title: "Backend Engineer (Node.js)", company: "Razorpay", salary: "18-24 LPA", location: "Bangalore", link: "#", type: "Product", category: "Development" },
    { id: 17, title: "Product Management Intern", company: "Cred", salary: "Stipend: 60k", location: "Bangalore", link: "#", type: "Product", category: "Product" },
    { id: 18, title: "DevOps Engineer", company: "Oracle", salary: "14-19 LPA", location: "Noida", link: "#", type: "MNC", category: "Cloud" },
    { id: 19, title: "Business Development", company: "Byju's", salary: "7-10 LPA", location: "Pan India", link: "#", type: "EdTech", category: "Sales" },
    { id: 20, title: "Java Developer", company: "Cognizant", salary: "4.5-7 LPA", location: "Kolkata", link: "#", type: "MNC", category: "Development" }
  ]);

  const styles = {
    container: {
      backgroundColor: '#F8F4FF',
      minHeight: '100vh',
      paddingBottom: '80px',
      fontFamily: "'Inter', sans-serif"
    },
    header: {
      background: 'linear-gradient(135deg, #4A148C 0%, #7B1FA2 100%)',
      color: 'white',
      padding: '100px 20px',
      textAlign: 'center',
      borderBottomLeftRadius: '60px',
      borderBottomRightRadius: '60px',
      boxShadow: '0 10px 40px rgba(74, 20, 140, 0.2)'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '25px',
      maxWidth: '1300px',
      margin: '-50px auto 0 auto',
      padding: '0 25px'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '24px',
      padding: '28px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
      border: '1px solid #E1BEE7',
      transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      position: 'relative',
      overflow: 'hidden'
    },
    badge: {
      position: 'absolute',
      top: '15px',
      right: '15px',
      background: '#F3E5F5',
      color: '#7B1FA2',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '0.75rem',
      fontWeight: '700'
    },
    title: { fontSize: '1.25rem', fontWeight: '800', color: '#311B92', marginBottom: '8px' },
    company: { color: '#9C27B0', fontWeight: '600', marginBottom: '18px', display: 'flex', alignItems: 'center', gap: '8px' },
    details: { fontSize: '0.85rem', color: '#666', marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '8px' },
    btn: {
      marginTop: '20px',
      width: '100%',
      padding: '12px',
      background: '#7B1FA2',
      color: 'white',
      border: 'none',
      borderRadius: '14px',
      fontWeight: '700',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      transition: '0.3s'
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={{fontSize: '3.5rem', marginBottom: '10px'}}>Mandi Hariyanna <span style={{color: '#E1BEE7'}}>Careers</span></h1>
        <p style={{fontSize: '1.2rem', opacity: 0.9}}>Official Placement Portal • Class of 2026 Opportunities</p>
      </header>

      <div style={styles.grid}>
        {jobs.map((job) => (
          <div 
            key={job.id} 
            style={styles.card}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.borderColor = '#9C27B0';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = '#E1BEE7';
            }}
          >
            <div style={styles.badge}>{job.type}</div>
            <h3 style={styles.title}>{job.title}</h3>
            <div style={styles.company}>
              <FaBuilding size={14}/> {job.company}
            </div>

            <div style={styles.details}><FaMapMarkerAlt /> {job.location}</div>
            <div style={styles.details}><FaMoneyBillWave /> {job.salary}</div>
            <div style={{marginTop: '10px', fontSize: '0.75rem', color: '#9C27B0', fontWeight: 'bold'}}>
              <FaRocket /> {job.category}
            </div>

            <button 
              style={styles.btn}
              onClick={() => window.open(job.link, '_blank')}
              onMouseOver={(e) => e.target.style.background = '#4A148C'}
              onMouseOut={(e) => e.target.style.background = '#7B1FA2'}
            >
              Apply Now <FaExternalLinkAlt size={12}/>
            </button>
          </div>
        ))}
      </div>

      <footer style={{textAlign: 'center', marginTop: '60px', color: '#4A148C', opacity: 0.6}}>
        <p>© 2026 Mandi Hariyanna Academy Placement Cell • Dedicated to Student Success</p>
      </footer>
    </div>
  );
};

export default PlacementPortal;